import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

import { logoutUser } from "../../slices/thunks";

//redux
import { useSelector, useDispatch } from "react-redux";

import withRouter from "../../Components/Common/withRouter";
import { createSelector } from "reselect";
import { showSuccessToast } from "../../helpers/toast_helper";

const Logout = () => {
  const dispatch: any = useDispatch();
  const [shouldRedirect, setShouldRedirect] = useState(false);


  const logoutData = createSelector(
    (state) => state.Login,
    (isUserLogout) => isUserLogout.isUserLogout
  );

  // Inside your component
  const isUserLogout = useSelector(logoutData);

  useEffect(() => {
   dispatch(logoutUser());
  }, [dispatch]);

   useEffect(() => {
    if (isUserLogout) {
      
      showSuccessToast("Logout successful!", "logout-success");
        setShouldRedirect(true);
    }
  }, [isUserLogout]);

  if (shouldRedirect) {
    return <Navigate to="/login" />;
  }

  return <React.Fragment></React.Fragment>;
};

Logout.propTypes = {
  history: PropTypes.object,
};


export default withRouter(Logout);